import { provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  ApplicationConfig,
  inject,
  isDevMode,
  provideAppInitializer,
} from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from "@angular/router";
import { provideTransloco, TranslocoService } from "@jsverse/transloco";
import { providePrimeNG } from "primeng/config";
import { lastValueFrom } from "rxjs";
import { appRoutes } from "./app.routes";
import concretePreset from "./assets/concrete-theme-preset";
import { tokenInterceptor } from "./interceptors/token.interceptor";
import { UserService } from "./services/user.service";
import { TranslocoHttpLoader } from "./transloco-loader";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      }),
      withEnabledBlockingInitialNavigation(),
    ),
    provideHttpClient(withInterceptors([tokenInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: concretePreset,
        options: {
          // TODO needs to be removed if we want to enable dark mode
          darkModeSelector: false,
        },
      },
    }),
    provideTransloco({
      config: {
        availableLangs: ["en", "hr"],
        defaultLang: "en",
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideAppInitializer(() => {
      const transloco = inject(TranslocoService);
      const lang = "en"; // or detect from storage or browser
      transloco.setActiveLang(lang);
      return lastValueFrom(transloco.load(lang)).then(() => {});
    }),
    provideAppInitializer(() => {
      const userService = inject(UserService);
      return userService.init();
    }),
  ],
};
